import { IAggricateObj, IBusinessParameter, ISingleValueReportList } from '../../Redux/VisualUnits/vuParamSlice'
import { FoundationsConstants } from '../../FoundationsConstants';
import { useRef, useEffect } from 'react';

const HLAggricateList = ({ data, selected, handleSelect, isFetchingResp }: any) => {
    let aggricateElementRef = useRef<Map<number, HTMLLIElement>>(new Map())

    useEffect(() => {
        //use effect responsible to scroll to selected aggrigates.. (Right list)
        if (Object.keys(selected).length > 0) {
            let index = selected?.selectedIndex
            const targetElement = aggricateElementRef.current.get(index)
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth', block:"nearest" })
            }
        }
    }, [selected?.selectedIndex])

    return (
        <ul className="aggregate-list">
            {data.aggricateListResp.length > 0 && data.displayType === FoundationsConstants.FetchVuParamsDisplayType.AggricateList &&
                data.aggricateListResp.map(
                    (item: IAggricateObj, aggrIndex: number) => {
                        return (
                            <li
                                key={`aggricate_item_${aggrIndex}`}
                                ref={(el) => {
                                    if (el) {
                                        aggricateElementRef.current.set(
                                            aggrIndex,
                                            el
                                        )
                                    }
                                }}
                                className={
                                    selected?.selectedIndex ===
                                        aggrIndex
                                        ? `selected`
                                    :
                                    `not-selected`
                                }
                                id={'aggregate_item_' + aggrIndex}
                                onClick={() => handleSelect({...item, selectedIndex: aggrIndex})}
                            >
                                <span className="fieldradio">
                                    <input
                                        type="radio"
                                        id={
                                            'aggregate_radio_' +
                                            aggrIndex
                                        }
                                        name="aggregate_radio_"
                                        checked={
                                            selected?.selectedIndex ===
                                            aggrIndex
                                        }
                                        readOnly
                                    />
                                </span>
                                <span
                                    className="fieldcontent"
                                    id="display_aggr_function_id_undefined"
                                >
                                    {item?.AggregateFunction}
                                </span>
                            </li>
                        )
                    }
                )}
            {data.businessParameterList.length > 0 && data.displayType === FoundationsConstants.FetchVuParamsDisplayType.BusinessParameterList &&
                data.businessParameterList.map(
                    (item: IBusinessParameter, bpIndex: number) => {
                        return (
                            <li
                                key={`businessParam_item_${bpIndex}`}
                                id={'bp_item_' + item.Id}
                                ref={(el) => {
                                    if (el) {
                                        aggricateElementRef.current.set(
                                            bpIndex,
                                            el
                                        )
                                    }
                                }}
                                className={
                                    selected?.selectedIndex ==
                                    bpIndex
                                        ? 'selected'
                                        : 
                                    'not-selected'
                                }
                            onClick={()=> handleSelect({...item, selectedIndex: bpIndex})}
                            >
                                <div className="float-left fieldradio">
                                    <input
                                        type="radio"
                                        id={'bp_radio_' + item.Id}
                                        name="bp_radio"
                                        checked={
                                            selected?.selectedIndex ===
                                            bpIndex
                                        }
                                        readOnly
                                    />
                                </div>
                                <div className="float-left fieldcontent">
                                    <div className="fieldname">
                                        {item.Name}
                                    </div>
                                    <div className="fielddesc">
                                        {item.Description}
                                    </div>
                                    <div className="fielddesc">
                                        Value: {item.BPValue}
                                    </div>
                                </div>
                                <div className="clear-both"></div>
                            </li>
                        )
                    }
                )}
            {data.singleValueReportList.length > 0 && data.displayType === FoundationsConstants.FetchVuParamsDisplayType.SingleValueReportList &&
                data.singleValueReportList.map(
                    (
                        item: ISingleValueReportList,
                        singleValIndex: number
                    ) => {
                        return (
                            <>
                                <li
                                    key={`singlevalue_item_${singleValIndex}`}
                                    ref={(el) => {
                                        if (el) {
                                            aggricateElementRef.current.set(
                                                singleValIndex,
                                                el
                                            )
                                        }
                                    }}
                                    id={'svr_item_' + item.id}
                                    className={
                                        selected?.selectedIndex ===
                                            singleValIndex
                                            ? 'selected'
                                            : 
                                        'not-selected'
                                    }
                                onClick={()=> handleSelect({...item, selectedIndex: singleValIndex})}
                                >
                                    <div className="float-left fieldradio">
                                        <input
                                            checked={selected?.selectedIndex === singleValIndex}
                                            type="radio"
                                            id={'svr_radio_' + item.id}
                                            name="svr_radio"
                                            readOnly
                                        />
                                    </div>
                                    <div className="float-left fieldcontent">
                                        <div className="fieldname">
                                            {item.name}
                                        </div>
                                        <div className="fielddesc">
                                            {item.description}
                                        </div>
                                    </div>
                                    <div className="clear-both"></div>
                                </li>
                            </>
                        )
                    }
                )}
                {isFetchingResp && <div className="padding-medium medium">Loading...</div>}
        </ul>
    )
}

export default HLAggricateList